import Immutable from 'immutable';
import {
  CHANGE_STEP,
  SEARCH_FOR_ITINERARIES,
  FLAG_SEARCHING_FOR_ITINERARIES,
  SELECT_ITINERARY_SEARCH_RESULT,
  SELECT_SEAT,
  DESELECT_SEAT,
  FLAG_SEAT_SELECTION_CHANGE_IN_PROGRESS,
  POST_RESERVATION_REQUESTS,
  POST_PAYMENT,
  FLAG_GETTING_PRINTED_TICKET,
  GET_PRINTED_TICKET,
  CLEAR_PRINTED_TICKETS,
  GET_INTINERARY_FOOD_GROUP,
  RESET_STEP,
  APPLY_CREDIT_NOTE,
  CANCEL_CREDIT_NOTE,
  FLAG_POSTING_PAYMENT,
  FLAG_POSTING_RESERVATION,
  SET_FIXED_PRICE_FOR_CURRENT_BOOKING,
  CLEAR_ITINERARY_FOR_BOOKING,
  CLEAR_SELECT_ITINERARY,
  CLEAR_SEATS_FOR_BOOKING,
  POST_KIDS_ON_ITINERARY,
  DELETE_KIDS_ON_ITINERARY,
  GET_RIDE_BOOKING_PRICE,
  SET_RIDE_BOOKING_TOTAL,
  CLEAR_RIDE_BOOKING_TOTAL,
  FLAG_ROAD_BOOKING_SEARCH_LOADING,
  SET_ROAD_BOOKING_SEARCH_RESULTS,
  SET_ROAD_BOOKING_ITINERARY_ID,
  SET_ROAD_BOOKING_SOURCE_CITY_ORIGIN,
  CHANGE_STEP_ROAD_BOOKING,
  SET_ROAD_BOOKING_STOPS_LOCATION,
  CLEAR_ROAD_BOOKING_STOPS_LOCATION,
  FLAG_ROAD_BOOKING_ACTIVITY,
  SET_ROAD_BOOKING_ITINERARY,
  CLEAR_ROAD_BOOKING_ITINERARY,
  SET_ROAD_BOOKING_DISCOUNT,
  CLEAR_ROAD_BOOKING_DISCOUNT,
  SET_ROAD_BOOKING_SOLD_SEATS,
  CLEAR_ROAD_BOOKING_SOLD_SEATS,
  ADD_ROAD_BOOKING_SOLD_SEAT,
  FLAG_GETTING_SEAT_RELEASE_PERMISSIONS,
  GET_SEAT_RELEASE_PERMISSIONS,
  CLEAR_SEAT_RELEASE_PERMISSIONS
} from '../../../actions/types';
import { tzNormalizeDate } from '../../../utils/date';
import { CIVA_ROAD_BOOKING_SEARCH_STEP_INDEX } from '../../../config/constants';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const SEARCH_STEP = 0;

const INITIAL_STATE = new Immutable.Map({
  currentStep: SEARCH_STEP,
  search: new Immutable.Map({
    query: new Immutable.Map({
      source: { value: 4, label: 'Lima' },
      destination: null,
      // number of passengers is just a number not an object
      numPassengers: null,
      time: tzNormalizeDate(),
    }),
  }),
  itineraries: new Immutable.Map({
    results: new Immutable.Map(),
    searchingForItineraries: false,
    selectedItinerarySearchResults: new Immutable.List(),
  }),
  seats: new Immutable.Map({
    seatSelectionChangesInProgress: new Immutable.Set(),
    seatReservations: new Immutable.Set(),
  }),
  passengers: new Immutable.Map({
    itineraryFoodGroup: null,
    postingReservation: false,
    kidsOnItinerary: new Immutable.Set(),
  }),
  payment: new Immutable.Map({
    customerOrder: new Immutable.Map(),
    creditNote: new Immutable.Map(),
    postingPayment: false,
    requiresTwoStepAuthorization: false,
  }),
  confirmation: Immutable.Map({
    reservationId: null,
    printedTickets: new Immutable.Set(),
    loading: false,
  }),
  pricing: new Immutable.Map({
    total: 0,
  }),
  roadBooking: new Immutable.Map({
    searchResults: new Immutable.List(),
    loading: false,
    itineraryId: null,
    sourceCityOrigin: null,
    currentStep: CIVA_ROAD_BOOKING_SEARCH_STEP_INDEX,
    stopsLocationList: new Immutable.List(),
    activity: new Immutable.List(),
    itinerary: new Immutable.Map(),
    discount: new Immutable.Map(),
    soldSeats: new Immutable.List(),
  }),
  seatReleasePermission: new Immutable.Map({
    content: new Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case RESET_STEP:
      return state.set(
        payload.statePropertyName,
        INITIAL_STATE.get(payload.statePropertyName),
      );
    case CHANGE_STEP:
      return state.set('currentStep', payload);
    case SEARCH_FOR_ITINERARIES:
      return (
        state
          // set the query
          .setIn(
            ['search', 'query'],
            new Immutable.Map({
              source: payload.source,
              destination: payload.destination,
              numPassengers: payload.numPassengers,
              time: payload.time,
            }),
          )
          // set the results
          .setIn(['itineraries', 'results'], new Immutable.Map(payload.results))
      );
    case FLAG_SEARCHING_FOR_ITINERARIES:
      return state.setIn(['itineraries', 'searchingForItineraries'], payload);
    case FLAG_POSTING_RESERVATION:
      return state.setIn(['passengers', 'postingReservation'], payload);
    case POST_KIDS_ON_ITINERARY:
      return state.setIn(
        ['passengers', 'kidsOnItinerary'],
        state.getIn(['passengers', 'kidsOnItinerary']).add(payload),
      );
    case DELETE_KIDS_ON_ITINERARY:
      return state.setIn(
        ['passengers', 'kidsOnItinerary'],
        state
          .getIn(['passengers', 'kidsOnItinerary'])
          .delete(
            state
              .getIn(['passengers', 'kidsOnItinerary'])
              .findKey((kidOnItinerary) => kidOnItinerary === payload),
          ),
      );
    case FLAG_POSTING_PAYMENT:
      return state.setIn(['payment', 'postingPayment'], payload);
    case SELECT_ITINERARY_SEARCH_RESULT:
      return state.setIn(
        ['itineraries', 'selectedItinerarySearchResults', payload.index],
        payload.itinerarySearchResult,
      );
    case CLEAR_ITINERARY_FOR_BOOKING:
      return state.setIn(['itineraries'], INITIAL_STATE.getIn(['itineraries']));
    case CLEAR_SELECT_ITINERARY:
      return state.setIn(
        ['itineraries', 'selectedItinerarySearchResults'],
        INITIAL_STATE.getIn(['itineraries', 'selectedItinerarySearchResults']),
      );
    case CLEAR_SEATS_FOR_BOOKING:
      return state.setIn(['seats'], INITIAL_STATE.getIn(['seats']));
    case FLAG_SEAT_SELECTION_CHANGE_IN_PROGRESS:
      // start seat selection change
      if (payload.status === 'start') {
        return state.setIn(
          ['seats', 'seatSelectionChangesInProgress'],
          state
            .getIn(['seats', 'seatSelectionChangesInProgress'])
            .add(payload.seatId),
        );
      }
      // stop seat selection change
      return state.setIn(
        ['seats', 'seatSelectionChangesInProgress'],
        state
          .getIn(['seats', 'seatSelectionChangesInProgress'])
          .remove(payload.seatId),
      );
    case SELECT_SEAT:
      return state.setIn(
        ['seats', 'seatReservations'],
        state.getIn(['seats', 'seatReservations']).add(payload),
      );
    case DESELECT_SEAT:
      return state.setIn(
        ['seats', 'seatReservations'],
        state
          .getIn(['seats', 'seatReservations'])
          .delete(
            state
              .getIn(['seats', 'seatReservations'])
              .findKey((seatReservation) => seatReservation.id === payload),
          ),
      );
    // todo: CLEAR_SEAT_RESERVATIONS
    case GET_INTINERARY_FOOD_GROUP:
      return state.setIn(['passengers', 'itineraryFoodGroup'], payload);
    case POST_RESERVATION_REQUESTS:
      return state.setIn(['payment', 'customerOrder'], Immutable.Map(payload));
    case APPLY_CREDIT_NOTE:
      return state.setIn(['payment', 'creditNote'], Immutable.Map(payload));
    case POST_PAYMENT:
      return state.setIn(['confirmation', 'reservationId'], payload);
    case CANCEL_CREDIT_NOTE:
      return state.setIn(
        ['payment', 'creditNote'],
        INITIAL_STATE.getIn(['payment', 'creditNote']),
      );
    case GET_PRINTED_TICKET:
      return state.setIn(
        ['confirmation', 'printedTickets'],
        Immutable.Set(payload),
      );

    case FLAG_GETTING_PRINTED_TICKET:
      return state.setIn(['confirmation', 'loading'], payload);

    case CLEAR_PRINTED_TICKETS:
      return state.setIn(['confirmation', 'printedTickets'], Immutable.Set());

    case SET_FIXED_PRICE_FOR_CURRENT_BOOKING: {
      const oldPassengers = [
        ...state.getIn(['payment', 'customerOrder', 'passengers']),
      ];
      const newPassengers = payload;
      oldPassengers.forEach((oldPassenger, index) => {
        newPassengers.forEach((newPassenger) => {
          if (oldPassenger.ticketId === newPassenger.ticketId) {
            oldPassengers[index].salePrice = newPassenger.fixedPrice;
          }
        });
      });
      return state.setIn(
        ['payment', 'customerOrder', 'passengers'],
        oldPassengers,
      );
    }
    case GET_RIDE_BOOKING_PRICE:
      return state.setIn(['pricing', 'total'], Number(payload) || 0);
    case SET_RIDE_BOOKING_TOTAL:
      return state.setIn(['pricing', 'total'], Number(payload) || 0);
    case CLEAR_RIDE_BOOKING_TOTAL:
      return state.setIn(['pricing', 'total'], 0);
    case FLAG_ROAD_BOOKING_SEARCH_LOADING:
      return state.setIn(['roadBooking', 'loading'], payload);
    case SET_ROAD_BOOKING_SEARCH_RESULTS:
      return state.setIn(
        ['roadBooking', 'searchResults'],
        Immutable.List(payload),
      );
    case SET_ROAD_BOOKING_ITINERARY_ID:
      return state.setIn(['roadBooking', 'itineraryId'], payload);
    case SET_ROAD_BOOKING_SOURCE_CITY_ORIGIN:
      return state.setIn(['roadBooking', 'sourceCityOrigin'], payload);
    case CHANGE_STEP_ROAD_BOOKING:
      return state.setIn(['roadBooking', 'currentStep'], payload);
    case SET_ROAD_BOOKING_STOPS_LOCATION:
      return state.setIn(
        ['roadBooking', 'stopsLocationList'],
        Immutable.List(payload),
      );
    case CLEAR_ROAD_BOOKING_STOPS_LOCATION:
      return state.setIn(['roadBooking', 'stopsLocationList'], Immutable.List());
    case FLAG_ROAD_BOOKING_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['roadBooking', 'activity'],
          state.getIn(['roadBooking', 'activity']).push(payload),
        );
      }
      return state.setIn(
        ['roadBooking', 'activity'],
        state.getIn(['roadBooking', 'activity']).pop(),
      );
    case SET_ROAD_BOOKING_ITINERARY:
      return state.setIn(['roadBooking', 'itinerary'], Immutable.Map(payload));
    case CLEAR_ROAD_BOOKING_ITINERARY:
      return state.setIn(['roadBooking', 'itinerary'], null);
    case SET_ROAD_BOOKING_DISCOUNT:
      return state.setIn(['roadBooking', 'discount'], Immutable.Map(payload));
    case CLEAR_ROAD_BOOKING_DISCOUNT:
      return state.setIn(['roadBooking', 'discount'], Immutable.Map());
    case SET_ROAD_BOOKING_SOLD_SEATS:
      return state.setIn(
        ['roadBooking', 'soldSeats'], Immutable.List(payload));
    case CLEAR_ROAD_BOOKING_SOLD_SEATS:
      return state.setIn(['roadBooking', 'soldSeats'], Immutable.List());
    case ADD_ROAD_BOOKING_SOLD_SEAT:
      return state.setIn(
        ['roadBooking', 'soldSeats'],
        state.getIn(['roadBooking', 'soldSeats']).push(payload),
      );
    case FLAG_GETTING_SEAT_RELEASE_PERMISSIONS:
      return state.setIn(['seatReleasePermission', 'loading'], payload);
    case GET_SEAT_RELEASE_PERMISSIONS:
      return state.setIn(
        ['seatReleasePermission', 'content'],
        Immutable.Map(payload),
      );
    case CLEAR_SEAT_RELEASE_PERMISSIONS:
      return state.setIn(
        ['seatReleasePermission', 'content'],
        Immutable.Map(COLLECTION_SHAPE),
      );
    default:
      return state;
  }
};
